import { styled } from "styled-components";
import PlayIcon from "../../assets/svg/playicon.svg";
import { BACKGROUND, FONTSIZE, FONTWEIGHT } from "../../constants/theme";

export const ExplanationStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: flex-start;
    flex-wrap: wrap;
`;

ExplanationStyled.UpperPart = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

ExplanationStyled.Title = styled.p`
    font-size: ${FONTSIZE.h1};
    font-weight: ${FONTWEIGHT.bold};
    margin: 0px;
`;

ExplanationStyled.Subtitle = styled.p`
    font-size: ${FONTSIZE.smallP};
    font-weight: ${FONTWEIGHT.normal};
    margin: 0px;
`;

ExplanationStyled.MidPart = styled.div``;

ExplanationStyled.Button = styled.div`
    display: flex;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: ${BACKGROUND.blue};
    cursor: pointer;
`;

ExplanationStyled.PlayIcon = styled.img.attrs({
    src: PlayIcon
})``;

ExplanationStyled.ButtonText = styled.p`
    margin: 0px;
    color: #FFF;
    font-size: ${FONTSIZE.bigP};
    font-weight: ${FONTWEIGHT.normal};
`;

ExplanationStyled.BottomPart = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
`;

ExplanationStyled.Text = styled.p`
    margin: 0px;
    font-size: ${FONTSIZE.bigP};
    font-weight: ${FONTWEIGHT.normal};
`;

ExplanationStyled.Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

ExplanationStyled.ModalContent = styled.div`
  position: relative;
  width: 80%;
  height: 80%;
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

ExplanationStyled.CloseButton = styled.button`
  position: absolute;
  top: 25px;
  right: 25px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
`;